module.exports = __webpack_public_path__ + "img/microphone.9200863b.svg";